<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#download-s"></use></svg>
  Hent driftstatus rapport
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>
<form [formGroup]="downloadReportFormGroup" (ngSubmit)="downloadReport()">
  <div mat-dialog-content class="report">
    <div class="form-row">
      <h2 class="form-headline">Organisation(er)</h2>
      <mat-form-field>
        <mat-select
          formControlName="selectedOrganizations"
          placeholder="Vælg en eller flere organisationer"
          multiple
          (selectionChange)="getDepartments()"
          okCustomDropDownArrowDirective>
          @for (organization of organizations; track organization) {
            <mat-option [value]="organization">
              {{ organization.name }}
            </mat-option>
          }
        </mat-select>
        @if (hasSelectedOrganizations()) {
          <span matSuffix>
            <button
              class="clear-input-field-button"
              type="button"
              (click)="reset('organizations', $event)"
              aria-label="Ryd indhold i feltet">
              <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
            </button>
          </span>
        }
        <span matSuffix></span>
      </mat-form-field>
    </div>
    <div class="form-row">
      <h2 class="form-headline">Afdeling(er)</h2>
      <mat-form-field>
        <mat-select
          formControlName="selectedDepartments"
          placeholder="Vælg en eller flere afdelinger"
          multiple
          (selectionChange)="getLocations()"
          okCustomDropDownArrowDirective>
          @for (department of departments; track department) {
            <mat-option [value]="department"> {{ department.name }} ({{ department.organizationName }}) </mat-option>
          }
        </mat-select>
        @if (hasSelectedDepartments()) {
          <span matSuffix>
            <button class="clear-input-field-button" type="button" (click)="reset('departments', $event)" aria-label="Ryd indhold i feltet">
              <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
            </button>
          </span>
        }
        <span matSuffix></span>
        @if (hasSelectedOrganizations()) {
          <mat-hint> <strong>Bemærk!</strong> Afdelingerne i listen er filtreret jvf. dit ovenstående valg af organisation(er). </mat-hint>
        }
      </mat-form-field>
    </div>
    <div class="form-row">
      <h2 class="form-headline">Lokation(er)</h2>
      <mat-form-field>
        <mat-select
          formControlName="selectedLocations"
          placeholder="Vælg en eller flere lokationer"
          multiple
          okCustomDropDownArrowDirective>
          @for (location of locations; track location) {
            <mat-option [value]="location">
              {{ location.name }} ({{ location.organizationName }} > {{ location.departmentName }})
            </mat-option>
          }
        </mat-select>

        @if (hasSelectedLocations()) {
          <span matSuffix>
            <button class="clear-input-field-button" type="button" (click)="reset('locations', $event)" aria-label="Ryd indhold i feltet">
              <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
            </button>
          </span>
        }
        <span matSuffix></span>
        @if (hasSelectedOrganizations() || hasSelectedDepartments()) {
          <mat-hint>
            <strong>Bemærk!</strong> Lokationerne i listen er filtreret jvf. dit ovenstående valg af organisationer og/eller afdelinger.
          </mat-hint>
        }
      </mat-form-field>
    </div>

    <div class="form-row margin--top-m">
      <h2 class="form-headline">Periode *</h2>
      <div class="daterange__datepicker">
        <mat-form-field>
          <mat-date-range-input [rangePicker]="picker" (click)="picker.open()">
            <input formControlName="startDate" class="pointer" readonly matStartDate placeholder="Start dato" #dateRangeStart />
            <input formControlName="endDate" class="pointer" readonly matEndDate placeholder="Slut dato" #dateRangeEnd />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button mat-dialog-close type="button" mat-button>Annuller</button>
    <button
      mat-flat-button
      class="btn"
      type="submit"
      color="primary"
      cdkFocusInitial
      [class.spinner]="loading"
      [disabled]="downloadReportFormGroup.invalid || loading">
      Download rapport
    </button>
  </mat-dialog-actions>
</form>
